import eightlyticsWrapper from './wraplytics'

const onload = () => {
  const handle = function(type, data, callback, widgetUuid) {
    if (type === 'getPurchaseSession') {
      window.eightlytics.client.getPurchaseSession(data || callback)
    } else {
      const { event, enrichedConfig, resolve } = eightlyticsWrapper(type, data, callback, widgetUuid)
      window.eightlytics.client.dispatchEvent(event, enrichedConfig, resolve)
    }
  }
  const process = function() {
    if (
      window.eightlytics.queue &&
      window.eightlytics.queue.constructor === Array &&
      window.eightlytics.queue.length > 0
    ) {
      handle(...window.eightlytics.queue.shift())
      process()
    } else {
      handle.client = window.eightlytics.client
      window.eightlytics = handle
    }
  }
  if (window.eightlytics.queue) {
    window.eightlytics.queue.unshift(['loadCSE'])
  }
  process()
}

export default onload
